module.exports = __webpack_public_path__ + "static/media/gs.f442c697.svg";